import { Swiper, Navigation, Autoplay } from "swiper/bundle";
export default class Swipernews {
    constructor() {
        console.log('%c👍🏼 Swiper News', 'color: yellow');
        
        this.swipernews = document.querySelectorAll('.swiper-news')
    }
    init() {
        this.swipernews.forEach((module, i) => {

            const elem = module.querySelector('.swiper--news')

            const nextButton = module.querySelector('.swiper-button-next')
            const prevButton = module.querySelector('.swiper-button-prev')
            new Swiper(elem, {
                slidesPerView: 1.5,
                loop: false,
                spaceBetween: 15,
                speed: 1001,

                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    540: {
                    slidesPerView: 1.7
                    },

                    768: {
                        slidesPerView: 2.2
                    },
                    998: {
                    slidesPerView: 3
                    },
                }
            });   
        })
    }
}